export interface SampleDTO {
    id: number;
    sampleCode: string;
    collectedBy: string;
    methode: string;
    collectionDate: string;  // Date sous forme de chaîne de caractères
  }

    export interface DetailDTO {
      id: number | null;
      typeAnalyseId: number;
      typeAnalyseNom: string;
      qte: number;
      prixUnitaire: number;
      total:number;
    }
    
    export interface DevisDTO {
      id: number;
      numeroDevis: string;
      clientReference: string; 
      action: string; 
      dateCreation: string;
      dateExpiration: string;
      dateLivraison: string;
      delaiLivraison: number;
      methodeExpedition: string;
      conditionReglement: string;
      totalHT: number;
      totalTTC: number;
      totalTVA: number;
      tva: number;
      tvaApplicable: boolean;
      accepted: boolean;
      validite: string;
      clientId: number;
      clientNom: string;  
      typeAnalyseNom: string;  
      details: DetailDTO[];
      status: StatutsDevis;  // Ajoutez un champ "status" si nécessaire
      updateDate:string;
      rapportPdfBase64?: string; // ← facultatif si parfois non présent

    }
  
    export enum StatutsDevis {
      BROUILLON = 'BROUILLON',
      EN_COURS = 'EN_COURS',
      VALIDE = 'VALIDE',
      ENVOYE = 'ENVOYE',
      ACCEPTE = 'ACCEPTE',
      REJETE = 'REJETE'
    }
    